export default __webpack_public_path__ + "static/media/genshin-razermouse.35fd42f0.jpg";